function bitsToBytes(bits: number) {
  return bits / 8;
}

export default bitsToBytes;
